// shared-types/src/gestionUser/types.ts
export enum GestionUserRole {
    OWNER = 'OWNER',
    ADMIN = 'ADMIN',
    ANALYST = 'ANALYST',
}

export enum GestionUserStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    LOCKED = 'LOCKED',
}

export interface GestionUser {
    id: string
    email: string
    passwordHash?: string
    name: string
    role: GestionUserRole
    status: GestionUserStatus
    lastLoginAt?: Date | null
    createdAt: Date
    updatedAt: Date
    deletedAt?: Date | null
}
